/**
 * useIgGrid — reads @flaxitup posts from marketing.meta_posts (populated by
 * meta-sync). Ordered newest first, ready to slot into an IG-style grid.
 */
import { useQuery } from '@tanstack/react-query';
import { marketing } from '@/lib/supabase/marketing';

export interface IgPost {
  media_id: string;
  media_type: string | null;
  caption: string | null;
  permalink: string | null;
  thumbnail_url: string | null;
  image_url: string | null;
  r2_thumb_key: string | null;
  r2_media_key: string | null;
  like_count: number | null;
  comments_count: number | null;
  views: number | null;
  reach: number | null;
  is_boosted: boolean | null;
  published_at: string;
}

export function useIgGrid(limit = 36) {
  return useQuery<IgPost[]>({
    queryKey: ['ig-grid', limit],
    queryFn: async () => {
      const { data, error } = await marketing
        .from('meta_posts')
        .select('media_id,media_type,caption,permalink,thumbnail_url,image_url,r2_thumb_key,r2_media_key,like_count,comments_count,views,reach,is_boosted,published_at')
        .eq('provider', 'instagram')
        .order('published_at', { ascending: false })
        .limit(limit);
      if (error) throw error;
      return (data ?? []) as IgPost[];
    },
    staleTime: 60_000,
  });
}
